import React, { useState, useEffect } from 'react';
import styles from './EditItems.module.css';

export default function EditItems({ items, onUpdate, onReset }) {
  const [drafts, setDrafts] = useState({});
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    const d = {};
    items.forEach(item => {
      d[item.id] = {
        locacao: item.locacao.toFixed(6),
        lavanderia: item.lavanderia.toFixed(6),
      };
    });
    setDrafts(d);
  }, [items]);

  const handleChange = (id, field, val) => {
    setDrafts(prev => ({
      ...prev,
      [id]: { ...prev[id], [field]: val },
    }));
  };

  const handleSave = () => {
    items.forEach(item => {
      const d = drafts[item.id];
      if (!d) return;
      const loc = parseFloat(d.locacao);
      const lav = parseFloat(d.lavanderia);
      if (!isNaN(loc) && !isNaN(lav)) {
        onUpdate(item.id, loc, lav);
      }
    });
    setSaved(true);
    setTimeout(() => setSaved(false), 2500);
  };

  const handleReset = () => {
    if (window.confirm('Restaurar todos os valores para os padroes da planilha?')) {
      onReset();
    }
  };

  return (
    <div className={styles.editor}>
      <div className={styles.editorHeader}>
        <div>
          <div className={styles.kicker}>Tabela operacional</div>
          <h2>Valores base</h2>
        </div>
        <button className={styles.resetBtn} onClick={handleReset}>
          Restaurar padroes
        </button>
      </div>

      <div className={styles.grid}>
        {items.map(item => {
          const d = drafts[item.id] || {};
          return (
            <div key={item.id} className={styles.row}>
              <div className={styles.label}>{item.name}</div>
              <div className={styles.fields}>
                <Field
                  label="Locacao"
                  value={d.locacao ?? ''}
                  onChange={v => handleChange(item.id, 'locacao', v)}
                />
                <Field
                  label="Lavanderia"
                  value={d.lavanderia ?? ''}
                  onChange={v => handleChange(item.id, 'lavanderia', v)}
                />
              </div>
            </div>
          );
        })}
      </div>

      <div className={styles.actions}>
        <button className={styles.saveBtn} onClick={handleSave}>
          {saved ? 'Salvo' : 'Salvar alteracoes'}
        </button>
      </div>
    </div>
  );
}

function Field({ label, value, onChange }) {
  return (
    <div className={styles.field}>
      <label className={styles.fieldLabel}>{label}</label>
      <input
        type="number"
        step="0.0001"
        min="0"
        className={styles.fieldInput}
        value={value}
        onChange={e => onChange(e.target.value)}
      />
    </div>
  );
}
